import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const AlertContainer = superstyled({
  tag: Box,
  name: 'PaymentAlert',
  slot: 'AlertContainer',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.red.light,
    borderRadius: theme.shape.borderRadius * 3,
    padding: theme.spacing(2, 3),
  }),
});
